import { useSound, SOUND_TYPE } from '@/Composables/sound'
import { useToast, TYPE as TOAST_TYPE } from 'vue-toastification'
import { settle } from '@/utils/promises'
import { useHardError } from '@/Composables/confirm-dialog'
// @Todo: Move to general constants
import { LANG } from '@/Composables/Fulfillment/constants'

export const useErrors = () => {
  const { show: showErrorModal } = useHardError()
  const { playSound } = useSound([SOUND_TYPE.ERROR])
  const toast = useToast()

  const showError = ({ message, confirmText, shouldPlaySound = true, useToast = false } = {}) => {
    if (shouldPlaySound) {
      playSound(SOUND_TYPE.ERROR)
    }

    const errorMessage = message ?? LANG.UNEXPECTED_ERROR

    if (useToast) {
      toast(errorMessage, { type: TOAST_TYPE.ERROR })
    } else {
      return showErrorModal({ message: errorMessage, confirmText })
    }
  }

  const showHardError = async ({ message, confirmText } = {}) => {
    await settle(showError({ message, confirmText }))
    window.location.reload()
  }

  return {
    showError,
    showHardError
  }
}
